<!-- name:一键注册 -->

<template>
  <div :class="{'quickly-register':true,'quickly-register-center':signStatus === 0}">
    <div class="item-img" v-if="signStatus === 0">
      <img :src="logoPng" width="188" height="60" alt=""/>
    </div>
    <template v-if="signStatus === 0">
      <el-form class="quickly-register-form" :model="ruleForm" :rules="rules" ref="ruleOneForm">
        <el-form-item prop="customer_name" style="position:relative;">
          <el-input :value="ruleForm.customer_name | name_filter(quickRegisterClientInfo.customer_type)"
                    @input="ruleForm.customer_name= $event.target.value" placeholder="名称" @blur="changBlur">
            <template slot="prepend">名称:</template>
          </el-input>
          <div style="position: absolute;left: 0;top: 0;width: 100%;height: 100%;z-index: 11;"></div>
        </el-form-item>
        <el-form-item prop="id_number" style="position:relative;">
          <el-input :value="ruleForm.id_number | idNo_filter" placeholder="证件号" @blur="changBlur">
            <template slot="prepend">证件号码:</template>
          </el-input>
          <div style="position: absolute;left: 0;top: 0;width: 100%;height: 100%;z-index: 11;"></div>
        </el-form-item>
        <el-form-item prop="mobile">
          <el-input v-model="ruleForm.mobile" placeholder="手机号" @blur="checkMobileIsUser()">
            <template slot="prepend">+86</template>
          </el-input>
        </el-form-item>
      </el-form>
      <el-form class="quickly-register-form" :model="ruleForm" :rules="rules" ref="ruleTwoForm">
        <!-- <el-form-item prop="captcha" v-if="captchaUrlShow">
          <el-input autocomplete="off" v-model="ruleForm.captcha" placeholder="图形验证码" @blur="changBlur">
            <template slot="append">
              <img style="width: 118px;" :src="captchaUrl" alt="获取图形验证码" @click="getVerifyCode()">
            </template>
          </el-input>
          <p>{{ captchaError }}</p>
          <el-input autocomplete="off" style="position: fixed;bottom:-99999px;opacity: 0;z-index: -3;"
                    placeholder="图形验证码"></el-input>
        </el-form-item> -->
        <el-form-item prop="code">
          <el-input v-model="ruleForm.code" placeholder="验证码" @blur="changBlur">
            <div slot="append">
              <el-button style="border-radius: 0;width:112px;font-weight:normal!important;border: 1px solid #dcdfe6;
    border-left-width: 0;border-right-width: 0;" type="primary" @click="sendMobileCode()"
                         :disabled="showTimeoutSeconds || !mobileIsUser || (captchaUrlShow && captchaIsError)"
                         :class="{'quickly-register-sendCodeButton':mobileIsUser && !showTimeoutSeconds && !captchaIsError}"  v-track-click="{eventId: 'quicklyRegisterGetCode', title: '一键注册-获取验证码' }">
                {{ showTimeoutSeconds ? `${timeoutSeconds} s` : '获取验证码' }}
              </el-button>
            </div>
          </el-input>
          <!-- 防止密码自动填充给账户号，给的隐藏输入框-->
          <el-input autocomplete="off" style="position: fixed;bottom:-99999px;opacity: 0;z-index: -3;"
                    placeholder="图形验证码"></el-input>
        </el-form-item>
      </el-form>
      <el-form class="quickly-register-form" :model="ruleForm" :rules="rules" ref="ruleThreeForm">
        <el-form-item prop="password">
          <el-input type="password" placeholder="密码" v-model="ruleForm.password" show-password
                    auto-complete="new-password" @blur="changBlur"></el-input>
        </el-form-item>
        <el-form-item prop="passwordAgain">
          <el-input type="password" placeholder="再次输入密码" v-model="ruleForm.passwordAgain" show-password
                    auto-complete="new-password" @blur="changBlur"></el-input>
        </el-form-item>
        <xt-checkbox v-model="ruleForm.mobile_disclosure_agree" style="margin-top: 30px;margin-bottom: 50px;"><span style="font-size: 12px;">同意使用该手机号码开通高毅资产客户服务系统账号(仅限中国大陆手机号码开通)</span></xt-checkbox>
        <el-form-item class="quickly-register-buttonRow">
          <el-button style="border-radius: 0;font-weight:normal!important;" type="primary" @click="submitForm()" :disabled="registerSubmitBoolean" v-track-click="{eventId: 'quicklyRegister', title: '一键注册', params: {data : this.ruleForm } }">注册
          </el-button>
        </el-form-item>
      </el-form>
    </template>
    <div class="div1" v-if="signStatus!==0 ">
      <div class="success-png" v-if="signStatus === 1">
        <div class="success-v"></div>
      </div>
      <div class="error" v-if="signStatus === 2||signStatus === 3">
        <span class="spanText">!</span>
      </div>
      <div v-if="signStatus === 1">
        <!--用户注册成功后 增加 5s倒计时 进入登录页   已经注册成功，点击链接再次进入只显示“已注册成功”-->
        <h3 style="margin-top: 15px" v-if="!isRegisterSuccessPost">已注册成功!</h3>
        <h3 style="margin-top: 15px" v-if="isRegisterSuccessPost">注册成功，<span style="margin-right: 5px;">{{ loginTime }}</span> 秒后跳转到登录页</h3>
      </div>
      <el-button v-if="signStatus === 1" @click="jumpLoginPage(false)" style="margin-top: 20px;border-radius: 0;" type="primary"
                 class="quickly-register-sendCodeButton jump-login-btn">立即跳转
      </el-button>
      <div v-if="signStatus === 2">
        <h3 style="margin-top: 15px">抱歉，您要访问的页面丢失了</h3>
        <p style="color:#999;margin-top: 15px">请检查您输入的网址是否正确</p>
      </div>
      <div v-if="signStatus === 3">
        <h3 style="margin-top: 15px">抱歉，您要访问的链接已经失效</h3>
      </div>
    </div>
  </div>
</template>

<script>

import XtCheckbox from "@/components/xtCheckbox.vue";

function replaceIdNoString(val) {
  if (!val) {
    return val
  }
  return val.substring(0, val.length - 4) + '****'
}

function replaceNameString(val, start_number) {
  let return_value = ""
  for (let i = 0; i < val.length; i++) {
    if (i < start_number) {
      return_value += val[i]
    } else {
      return_value += '*'
    }
  }
  return return_value
}

import {
  getQuickRegisterClientInfo,
  sendRegisterMessageNew,
  getCaptchaUrl,
  checkCaptcha
} from '@/service/support'
import {registValidateMsgCode, saveQuicklyRegisterPost} from '@/service/regist'
import logoPng from './../../assets/logo_blue.png'
import {getMobileTest} from "@/util"
import { tencentVerification } from '../../util/common'
import {getFailCount} from '@/service/login'

export default {
  name: "quicklyRegister",
  components: {XtCheckbox},
  data() {
    let validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'));
      } else {
        if (!getMobileTest(value)) {
          callback(new Error('请输入正确的11位手机号码'));
        } else if (value !== this.quickRegisterClientInfo.mobile) {
          callback(new Error('请输入预留的手机号'));
        }
        callback();
      }
    };
    let validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(value)) {
          callback(new Error('请输入8-16位字母数字组合的密码'));
        }
        if (this.ruleForm.passwordAgain !== '') {
          this.$refs.ruleThreeForm.validateField('passwordAgain');
        }
        callback();
      }
    };
    let validatePasswordAgain = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        if (!/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/.test(value)) {
          callback(new Error('请输入8-16位字母数字组合的密码'));
        }
        callback();
      }
    };
    let validateCode = async (rule, value, callback) => {
      if (!value) {
        callback(new Error('验证码不可为空'));
      } else {
        //校验手机短信验证码
        if (this.checkCodeBoolean) {
          let response
          try {
            response = await registValidateMsgCode(this.ruleForm.mobile, value)
            let {success, message} = response
            if (!success) {
              message = message ? message : "验证码不正确"
              callback(new Error(message));
            } else {
              callback();
            }
          } catch (e) {
            let {message} = response
            let errorMsg = message ? message : "验证码不正确"
            callback(new Error(errorMsg));
          }
        } else {
          callback();
        }

      }
    }
    let validateCaptcha = async (rule, value, callback) => {
      if (!value) {
        this.captchaIsError = true
        callback(new Error('图形验证码不可为空'));
      } else {
        let captchaFlag = await checkCaptcha(value)
        if (!captchaFlag) {
          this.captchaIsError = true
          callback(new Error('图形验证码不正确'));
        } else {
          this.captchaIsError = false
          callback()
        }
      }
    }
    return {
      sign: "",
      logoPng: logoPng,
      password: "xx",
      ruleForm: {
        customer_name: '',
        id_number: "",
        mobile: '',
        code: "",
        captcha: "",
        password: "",
        passwordAgain: "",
        clientId: "",
        mobile_disclosure_agree: true
      },
      rules: {
        customer_name: [
          {required: true, message: '请输入名称', trigger: 'blur'},
        ],
        id_number: [
          {required: true, message: '请输入证件号码', trigger: 'blur'},
        ],
        mobile: [
          {validator: validateMobile, trigger: 'blur'}
        ],
        code: [
          {validator: validateCode, trigger: 'blur'}
        ],
        captcha: [
          {validator: validateCaptcha, trigger: 'blur'}
        ],
        password: [
          {validator: validatePassword, trigger: 'blur'}
        ],
        passwordAgain: [
          {validator: validatePasswordAgain, trigger: 'blur'}
        ]
      },
      timeoutSeconds: 60,
      showTimeoutSeconds: false,
      mobileIsUser: false,
     // sendCodeCount: 0, //发送申请验证次数
      //customer_type: "", //客户类型0机构1个人3B级账户4子基金5FOF
      quickRegisterClientInfo: {
        client_id: ""
      },
      errorMessage: "",
      captchaUrlShow: false,
      captchaIsError: false,
      captchaUrl: "",
      captchaError: "",
      checkCodeBoolean: false,
      isSubmitBoolean: false,
      signStatus: '', // 注册状态 0 待注册  1 已经注册  2 其他异常（解密失败等）
      isRegisterSuccessPost: false,
      loginTime: 5
    }
  },
  computed: {
    registerSubmitBoolean() {
      let {customer_name, id_number, mobile, code, passwordAgain, password, clientId, mobile_disclosure_agree} = this.ruleForm
      //发送短信验证码超过三次的 需要校验图形验证码
    /*
      if (!this.captchaUrlShow) {
        return  !(customer_name && id_number && mobile && code && passwordAgain && password && clientId)
      } else {
        return  !(customer_name && id_number && mobile && code && passwordAgain && password && captcha && clientId)
      }
      */

      return  !(customer_name && id_number && mobile && code && passwordAgain && password && clientId && mobile_disclosure_agree)
    }
  },
  async created() {
    let {sign} = this.$route.query
    if (!sign) {
      console.log("链接不完整", 'sign=', sign)
      this.signStatus = 2
      return
    }
    let {code, data, success} = await getQuickRegisterClientInfo(sign)
    if (success) {
      this.signStatus = 0
      this.quickRegisterClientInfo = data
      let {customer_name, id_number, client_id} = this.quickRegisterClientInfo
      this.ruleForm.customer_name = customer_name
      this.ruleForm.id_number = id_number
      this.ruleForm.clientId = client_id
    } else {
      this.quickRegisterClientInfo = {}
      // console.log("加密数据获取失败 1001 已经注册  1002注册异常 1003超过24小时失效 code=", code)
      if (code === 1001) {
        this.signStatus = 1
      } else if (code === 1002) {
        this.signStatus = 2
      } else if (code === 1003) {
        this.signStatus = 3
      } else {
        this.signStatus = 2
      }
    }
  },
  methods: {
    changBlur() {
      //失焦后强制让页面归位 调起输入框，页面上推，输入框关闭无法恢复的问题
      let timer = setTimeout(function () {
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
        clearTimeout(timer)
      }, 100);
    },
    checkMobileIsUser() {
      // console.log('校验手机号是本人的解开验证码发送限制')
      this.mobileIsUser = this.ruleForm.mobile === this.quickRegisterClientInfo.mobile
      this.changBlur()
    },
    async sendMobileCode() {
      if (this.showTimeoutSeconds || !this.mobileIsUser) {
        // 已经发送 或 非本人手机号 不要重复请求
        return
      }

      try {
       tencentVerification(async(ticket, randStr) => {
            await sendRegisterMessageNew({
            mobile: this.ruleForm.mobile,
            isQuicklyRegist: true,
            ticket, randStr
              })
              this.showTimeoutSeconds = true
              this.timeoutSeconds = 60
              let timer = setInterval(() => {
                this.timeoutSeconds -= 1
                if (this.timeoutSeconds <= 0) {
                  this.showTimeoutSeconds = false
                  clearInterval(timer)
                }
              }, 1000)
         }, () => {
          this.$message({
          showClose: true,
          message: '网络异常，请稍后重试，或联系工作人员',
          type: 'error',
          center: true,
          customClass: 'custom-message-class' // 自定义类名
        });
        })

      } catch (err) {
        console.log('短信发送失败', err.code, err)
      }
    },
   // async getVerifyCode() {
   //   try {
        // 获取图片img base64地址
   //     this.captchaUrl = await getCaptchaUrl()
   //   } catch (error) {
    //    window.alert(`错误信息：${error.message}, 错误代码：${error.code}`)
    //  }
  //  },
    jumpLoginPage(needTime = true) {
      if (!needTime) {
        this.$router.replace({path: '/login'})
      } else {
        this.loginTime = 5
        this.isRegisterSuccessPost = true;
        let timer = setInterval(() => {
          this.loginTime--
          if (!this.loginTime) {
            clearInterval(timer)
            this.$router.replace({path: '/login'})
          }
        }, 1000)
      }

    },
    async submitForm() {
      if (this.isSubmitBoolean) {
        // console.log("还在跑注册不要重复点击")
        return
      }
      this.$refs.ruleOneForm.validate(async (valid) => {
        if (valid) {
          this.$refs.ruleThreeForm.validate(async (validThree) => {
            if (validThree) {
              this.checkCodeBoolean = true
              this.$refs.ruleTwoForm.validate(async (validTwo) => {
                if (validTwo) {
                  // console.log("信息正确 进入注册接口")
                  let {clientId, password, mobile, mobile_disclosure_agree} = this.ruleForm
                  let {success, message} = await saveQuicklyRegisterPost({clientId, password, mobile, mobile_disclosure_agree})
                  if (success) {
                    this.signStatus = 1
                    this.jumpLoginPage()
                  } else {
                    this.$message.error(`注册失败，请您重试！${message}`);
                    console.log("一键注册失败")
                  }
                } else {
                  this.isSubmitBoolean = false;
                  this.checkCodeBoolean = false
                  return false;
                }
              })
            } else {
              this.isSubmitBoolean = false;
              this.checkCodeBoolean = false
              return false;
            }
          })
        } else {
          this.isSubmitBoolean = false;
          this.checkCodeBoolean = false
          return false;
        }
      });
    }

  },
  filters: {
    name_filter(val, type) {
      //个人类型  显示第一个字符 其余***
      //机构类型 显示第一第二字符 其余***
      switch (type) {
        case '0': {
          return replaceNameString(val, 2)
          break
        }
        case '1': {
          return replaceNameString(val, 1)
          break
        }
        default: {
          return val
        }
      }
    },
    idNo_filter(val) {
      return replaceIdNoString(val)
    }
  }
}
</script>

<style lang="less">
.quickly-register {
  max-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  //padding: 25px 10px;
  background: #fff;
  overflow: auto;

  button {
    font-family: 'pingfang SC', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-weight: normal;
    font-size: 14px;
  }

  input::-webkit-input-placeholder {
    color: #999;
  }

  input::-ms-input-placeholder {
    color: #999;
  }

  .el-input-group__prepend {
    background-color: #fff;
    border: 1px solid rgb(204, 204, 204);
    border-right: 0;
    border-radius: 0;
    color: #333;
  }

  .el-form-item.is-success .el-input__inner, .el-form-item.is-success .el-input__inner:focus,
  .el-form-item.is-success .el-textarea__inner, .el-form-item.is-success .el-textarea__inner:focus {
    border-color: #CCC;
  }


  .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    border: 1px solid rgb(204, 204, 204);
    border-radius: 0;
    color: #333;
    cursor: not-allowed;
  }

  .el-input-group--prepend .el-input__inner {
    border-radius: 0;
  }

  .el-input-group--append .el-input__inner {
    border-radius: 0;
  }

  .el-input--suffix .el-input__inner {
    border-radius: 0;
  }

  .el-input-group__append {
    border: 0;
    //border-left: 0;
    //border-top-left-radius: 0;
    //border-bottom-left-radius: 0;
    //border-radius: 0;
  }

  .el-input__inner {
    color: #333;
  }

  .item-img {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    margin-bottom: 50px;
    //position: absolute;
    //left: 50%;
    //top: 10%;
    //transform: translate(-50%, 30px);
  }

  .quickly-register-form {
    width: 80%;

    .el-form-item {
      margin-bottom: 10px;
    }

    .el-form-item.is-error {
      margin-bottom: 22px;
    }
  }

  .quickly-register-timeoutSeconds {
    color: #4C7EC5;
  }


  .el-button--primary.is-disabled, .el-button--primary.is-disabled:hover,
  .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:active {
    background-color: #ccc;
    border-color: #ccc;
    color: #fff;
    cursor: not-allowed;
  }

  .quickly-register-buttonRow {
    .el-form-item__content {
      display: flex;
      justify-content: center;
      align-items: center;

      button {
        width: 100%;
      }
    }
  }

  .quickly-register-sendCodeButton {
    color: #fff !important;
    background-color: #4C7EC5 !important;
  }


  .success-png {
    margin: 0 auto;
    width: 50px;
    height: 50px;
    background: #D9E9FF;
    border-radius: 40px 40px;
  }

  .success-v {
    width: 20px;
    height: 10px;
    border: 3px solid #4C7EC5;
    border-right: none;
    border-top: none;
    transform: rotate(-45deg) translateX(-1px) translateY(21px);
  }

  .success-text {
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 21px;
    font-weight: 600;
    line-height: 30px;
  }

  .error {
    margin: 0 auto;
    background-color: lightpink;
    border-radius: 40px 40px;
    width: 50px;
    height: 50px;
    text-align: center;
  }

  .spanText {
    font-size: 30px;
    color: firebrick;
    line-height: 50px;
  }

  .div1 {
    border-radius: 5px;
    text-align: center;
    width: 100%;
  }
  .jump-login-btn{
    width: 80%;
  }


}

@media screen and (min-width: 1024px) {

  .quickly-register {
    max-height: 100%;
    max-width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;

    .item-img {
      justify-content: flex-start;
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      background: #fff;
      padding: 20px 10px;
      //transform: translate(0, 0);
    }

    .quickly-register-form {
      width: 55%;
    }
    .jump-login-btn{
      width: 230px;
    }

  }

  .quickly-register-center {
    max-width: 1024px;
    max-height: 600px;
  }


}


</style>
